//import { gen } from "gen";

import config from "config";

export type Product = {
  title: string;
  groups: ProductGroup[];
  basePrice: number;
};

export type ProductGroup = {
  title: string;
  code: string;
  accessories: Accessory[];
  //for parsing only
};

export type Accessory = {
  name: string;
  code: string;
  options: Option[];
};

export type Option = {
  name: string;
  code: string;
  optional: boolean;
  color?: string;
  selected?: boolean;
  price?: number;
  fixed?: boolean;
  image?: string;
  description?: string;
};

// let basisSet: ProductGroup = {
//   title: "Basis set",
//   code: "basisSet",
//   matchWebgroups: ["1", "4"],
//   accessories: []
// };

// let electraAccessoires: ProductGroup = {
//   title: "Electra accessoires",
//   code: "electraAccessoires",
//   matchWebgroups: ["5", "3"],
//   accessories: []
// };

// let verdereAccessoires: ProductGroup = {
//   title: "Verdere accessoires",
//   code: "verdereAccessoires",
//   matchWebgroups: ["6"],
//   accessories: []
// };

export function getData(data: any): Product {
  const result: Product = {
    title: "Desk Cube",
    basePrice: 0,
    groups: []
  };
  if (!data) return result;

  data.data.articles[0].article.forEach((a: any) => {
    let article = getArticle(a);

    let group = result.groups.find((g) => g.code === article.group);
    if (!group) {
      group = createGroup(article);
      result.groups.push(group);
    }

    let accessory = group.accessories.find((a) => a.code === article.product);
    if (!accessory) {
      accessory = createAccessory(article);
      group.accessories.push(accessory);
    }

    let opt = createOption(article);
    if (opt.code === "DCB01") {
      opt.selected = true;
      opt.fixed = true;
    }
    if (opt.code === config.viltLight) {
      opt.selected = true;
    }
    if (article.group === "Basis set") {
      opt.optional = false;
    }
    accessory.options.push(opt);
  });

  //gen(result);

  return result;
}

type Article = {
  id: string;
  group: string;
  product: string;
  title: string;
  price: number;
  vat: number;
  image?: string;
  thumb?: string;
  description?: string;
};

function getArticle(o: any): Article {
  let result: Article = {
    id: o.id,
    group: o.extra1?.xml?.group,
    product: o.extra1?.xml?.product,
    title: o.extra1?.xml?.title,
    price: parseFloat(o.price),
    vat: parseFloat(o.vat),
    image: o.image && o.image !== "" ? o.image : undefined,
    thumb: o.thumbnail && o.thumbnail !== "" ? o.thumbnail : undefined,
    description: o.descriptionlong && o.descriptionlong !== "" ? o.descriptionlong : undefined
  };

  return result;
}

function createGroup(a: Article): ProductGroup {
  let result: ProductGroup = {
    title: a.group,
    code: a.group,
    accessories: []
  };
  return result;
}

function createAccessory(a: Article): Accessory {
  let result: Accessory = {
    name: a.product,
    code: a.product,
    options: []
  };
  return result;
}

function createOption(a: Article): Option {
  let result: Option = {
    name: a.title,
    code: a.id,
    price: a.price,
    optional: true,
    image: a.image,
    description: a.description
  };
  return result;
}
